import React, { useState, useRef, useEffect } from 'react';
import ApiService from '../../../services/ApiService';
import { toast } from 'react-toastify';

const RoomStatusModal = ({
    show,
    onClose,
    onSuccess,
    onLoadingChange,
    statusName,
    statusNameApi,
    externalId,
    propertiesId
}) => {
    const [loading, setLoading] = useState(false);
    // Capture props when modal opens so Confirm always calls API with the status user chose (avoids stale closure)
    const payloadRef = useRef(null);
    useEffect(() => {
        if (show && statusNameApi && externalId && propertiesId) {
            payloadRef.current = {
                status_name_api: statusNameApi,
                external_id: externalId,
                properties_id: propertiesId
            };
        } else if (!show) {
            payloadRef.current = null;
        }
    }, [show, statusNameApi, externalId, propertiesId]);

    const handleConfirm = async () => {
        const payload = payloadRef.current || {
            status_name_api: statusNameApi,
            external_id: externalId,
            properties_id: propertiesId
        };
        console.log('[RoomStatusModal] handleConfirm called', {
            payloadRefCurrent: payloadRef.current,
            props: { statusNameApi, externalId, propertiesId },
            payloadUsed: payload,
            missingStatus: !payload.status_name_api,
            missingExternalId: !payload.external_id,
            missingPropertiesId: !payload.properties_id,
            willCallApi: !!(payload.status_name_api && payload.external_id && payload.properties_id)
        });
        if (!payload.status_name_api || !payload.external_id || !payload.properties_id) {
            console.warn('[RoomStatusModal] NOT calling API — missing required parameters');
            toast.error('Missing required parameters');
            return;
        }

        console.log('[RoomStatusModal] Calling API /updateroomstatusdirect with', payload);
        setLoading(true);
        if (onLoadingChange) onLoadingChange(true);
        try {
            const response = await ApiService.post('/updateroomstatusdirect', {
                status_name_api: payload.status_name_api,
                external_id: payload.external_id,
                properties_id: payload.properties_id,
                comment: ''
            });

            console.log('[RoomStatusModal] API response', { response: response?.data, hasData: !!response?.data });
            if (response?.data) {
                onSuccess();
            } else {
                console.warn('[RoomStatusModal] API returned no data');
                toast.error('Failed to update room status');
            }
        } catch (error) {
            console.error('[RoomStatusModal] Error updating room status:', error);
            toast.error('Failed to update room status');
        } finally {
            setLoading(false);
            if (onLoadingChange) onLoadingChange(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    if (!show) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="roomStatusModalLabel"
            aria-hidden="true"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="roomStatusModalLabel">
                            Set Room Status to {statusName}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handleClose}
                            disabled={loading}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-0">Are you sure you want to set the room status to <strong>{statusName}</strong>?</p>
                    </div>
                    <div className="modal-footer justify-content-center border-0 gap-3 pt-0">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleConfirm}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Updating...
                                </>
                            ) : (
                                'Confirm'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoomStatusModal;

